"use client";
import {
  badge_default
} from "./chunk-MDTP7BRB.mjs";
import {
  useBadge
} from "./chunk-6FKWSXYX.mjs";
export {
  badge_default as Badge,
  useBadge
};
